import script from "./list-accessory-name.vue?vue&type=script&setup=true&lang=ts"
export * from "./list-accessory-name.vue?vue&type=script&setup=true&lang=ts"

import "./list-accessory-name.vue?vue&type=style&index=0&id=5adcf971&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5adcf971"]])

export default __exports__